<!-- 工作区顶部信息 - 工作区配额 -->
<template>
  <div class="left">
    <div class="left-label">工作区配额：</div>
    <base-button
      v-if="(teamStore.isWorkbenchOwner || teamStore.isWorkbenchManager) && !teamStore.isTeamUserDisabled"
      class="workbench-btn buy-btn"
      type="default"
      @click="goPay"
    >
      增购配额
    </base-button>
    <!-- 没有权限占位 -->
    <div v-else style="height: 20px"></div>
  </div>
  <template v-if="teamStore.isInitStaticsData">
    <ul class="config">
      <li class="config-list">
        <div>{{ storage }}</div>
        <div>数据提交量</div>
      </li>
      <li class="config-list">
        <div>{{ capacity }}</div>
        <div>附件容量</div>
      </li>
      <li class="config-list">
        <div>{{ email }}</div>
        <div>邮件发送量</div>
      </li>
      <li class="config-list">
        <div>{{ sms }}</div>
        <div>短信发送量</div>
      </li>
    </ul>
  </template>
  <!-- 骨架屏 -->
  <div v-else class="skeleton-main">
    <workbench-info-skeleton :width="276" :height="22"></workbench-info-skeleton>
    <workbench-info-skeleton :width="276" :height="22"></workbench-info-skeleton>
  </div>
</template>

<script setup lang="ts">
import { watch, ref, defineAsyncComponent } from 'vue';
import { usePTeamStore } from '@/store';
import BaseButton from '@/components/base-button.vue';
import { apiGetPaymentConfig } from '@vas2t-lowcode/api';
import { dwClickPayQuota } from './workbench-info-dw';
import { getPositionRule } from '@/utils';

const WorkbenchInfoSkeleton = defineAsyncComponent(() => import('./workbench-info-skeleton.vue'));

const emit = defineEmits<{
  (e: 'set-pay-config-to-pay', data: any): void;
}>();

const teamStore = usePTeamStore();

/** 数据存储 */
const storage = ref('0');
/** 附件容量 */
const capacity = ref('0');
/** 邮件 */
const email = ref(0);
/** 短信 */
const sms = ref(0);

watch(
  () => teamStore.statics?.team_quotas,
  (val) => {
    if (val && val.length) {
      val.forEach((item) => {
        item.quota;
        switch (item.quota) {
          case 1:
            storage.value = item.count + 'W';
            break;
          case 2:
            capacity.value = item.count + 'G';
            break;
          case 3:
            email.value = item.count || 0;
            break;
          case 4:
            sms.value = item.count || 0;
            break;
        }
      });
    }
  },
  { immediate: true }
);

/**
 * 支付函数
 */
async function goPay() {
  // 埋点
  dwClickPayQuota();

  // 通过接口获取轻流payconfig 和 id
  let payconfigStr = '';
  let platform_id = '';
  try {
    const { data } = await apiGetPaymentConfig();
    payconfigStr = data.quota_mode || '';
    platform_id = data.qingflow_platform_id || '';
  } catch (error) {
    // 获取支付配置失败
    console.log(error);
    return;
  }

  const payConfig = {
    isClient: false,
    // 运营/产品 提供
    from_name: 'vas2t',
    csource: payconfigStr,
    position: getPositionRule({
      create_time: teamStore.statics?.team_rights?.create_time || 0,
      member_level: teamStore.statics?.team_rights?.member_level || '',
      position: 'quota',
    }),
    // 接口获取
    payconfig: payconfigStr,
    // 支付配置
    extra: '',
  };

  const extra = {
    purchase_type: 1,
    team_id: teamStore.statics?.curr_team_info?.team_id,
    platform_id,
  };

  payConfig.extra = JSON.stringify(extra);

  // 设置支付参数,调起支付
  emit('set-pay-config-to-pay', payConfig);
}
</script>

<style lang="scss" scoped>
.left {
  margin-right: 14px;
  &-label {
    font-size: 12px;
    line-height: 22px;
    margin-bottom: 10px;
  }
}

:deep(.buy-btn) {
  width: 64px;
}
.config {
  display: flex;

  &-list {
    margin-right: 16px;
    text-align: center;
    &:last-child {
      margin-right: 0;
    }
    > div:nth-of-type(1) {
      font-size: 14px;
      min-height: 22px;
      line-height: 22px;
      color: #ffffff;
      margin-bottom: 7px;
    }

    > div:nth-of-type(2) {
      font-size: 12px;
      line-height: 22px;
      color: rgba(255, 255, 255, 0.8);
    }
  }
}

.skeleton-main {
  > div:nth-of-type(1) {
    margin-bottom: 11px;
  }
}
</style>
